import React, { useContext } from 'react';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Grid } from '@wds/grid';
import { Typography } from '@wds/typography';
import { StaticContext } from '@sm/webassets/StaticContext';
import FortuneCallout from '~app/components/FortuneCallout/FortuneCallout';
import ColoredLogoWithText from '~app/components/surveyThanksLogo/ColoredLogoWithText';
import HeroCard from '~app/components/HeroCard';
import useStyle from './useStyles';
import { DARE_TO_ASK_COPY } from '~app/components/endpages/DareToAsk';
import { MAIN_HEADING_COPY, UPDATED_CARDS_COPY } from './copy';

function UpdatedExistingUser({ utSource2 }: { utSource2: string }): React.ReactElement {
  const utSource = 'survey-thanks';
  const utSource3 = 'UpdatedExistingUser';
  const { wrapper } = useStyle();
  const {
    smParams: { surveyId, collectorId, respondentId },
    templateType,
  } = useContext(StaticContext);

  return (
    <>
      <ColoredLogoWithText
        headerSize="md"
        isResearchPage
        isThanksText
        utSource={utSource}
        utSource2={utSource2}
        amplitudeEvent="updated existing user header"
      />
      <Box pl={4} pr={4}>
        <Box display="flex" justifyContent="center" pl={4} pr={4} pt={2} pb={1} mb={7} mt={7}>
          <Typography align="center" weight="medium" component="h1" variant="pageTitle">
            {MAIN_HEADING_COPY}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <Box className={wrapper}>
            <Grid noBleeds pb={7}>
              {UPDATED_CARDS_COPY.map(card => (
                <Grid.Item key={card.header} noGutters xl={4} lg={4} md={12} sm={12} xs={12}>
                  <HeroCard
                    amplitudeEvent={card.amplitudeEvent}
                    image={card.image.src}
                    imageAlt={card.image.alt}
                    header={card.header}
                    subHeader={card.subHeader}
                    ctaText={card.ctaText}
                    surveyId={surveyId}
                    collectorId={collectorId}
                    respondentId={respondentId}
                    utSource={utSource}
                    utSource2={utSource2}
                    utSource3={utSource3}
                    templateType={templateType}
                    ctaLink={card.ctaURL}
                    ctaUsage={card.ctaUsage}
                  />
                </Grid.Item>
              ))}
            </Grid>
          </Box>
        </Box>
        <FortuneCallout
          showLogoWall
          copy={t(DARE_TO_ASK_COPY.ALT_FORTUNE_CALLOUT_COPY)}
          color="white"
          utSource={utSource}
          utSource2={utSource2}
          hideCTAs
        />
      </Box>
    </>
  );
}

export default UpdatedExistingUser;
